var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6473_5047)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#F1D07C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4663 0H-1.46706C-3.08709 0 -4.40039 1.3133 -4.40039 2.93333V19.0667C-4.40039 20.6867 -3.08709 22 -1.46706 22H23.4663C25.0863 22 26.3996 20.6867 26.3996 19.0667V2.93333C26.3996 1.3133 25.0863 0 23.4663 0Z",
    fill: "#F1D07C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.40039 0L26.3996 20.5333L26.2192 22.1467L-4.40039 22V0Z",
    fill: "#6FB1D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8545 17.1455H17L16.0732 17.8545L16.4268 19L15.5 18.292L14.5732 19L14.9268 17.8545L14 17.1455H15.1455L15.5 16L15.8545 17.1455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8545 14.1455H13L12.0732 14.8545L12.4268 16L11.5 15.292L10.5732 16L10.9268 14.8545L10 14.1455H11.1455L11.5 13L11.8545 14.1455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85449 11.1455H9L8.07324 11.8545L8.42676 13L7.5 12.292L6.57324 13L6.92676 11.8545L6 11.1455H7.14551L7.5 10L7.85449 11.1455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85449 8.14551H5L4.07324 8.85449L4.42676 10L3.5 9.29199L2.57324 10L2.92676 8.85449L2 8.14551H3.14551L3.5 7L3.85449 8.14551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6473_5047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBs);
export default __webpack_public_path__ + "static/media/bs.d64a4a919afa990df6c71776b0c34642.svg";
export { ForwardRef as ReactComponent };